import Accordion from '@/common/components/Accordion'
import TextField from '@/common/components/TextField'
import { BankAccountInformation } from '@/common/types/establishment/company.type'
import { formatCnpjCpf } from '@/common/utils/formatters'
import { BankAccountUpdateModal } from './BankAccountUpdateModal'

interface BankAccountSectionProps {
  establishmentCompanyId?: string
  establishmentCompanyBranchId?: string
  bankAccountInformation?: BankAccountInformation
  establishmentCompanyIsLoading?: boolean
}

export const BankAccountSection = ({
  establishmentCompanyId,
  establishmentCompanyBranchId,
  bankAccountInformation,
  establishmentCompanyIsLoading,
}: BankAccountSectionProps) => {
  return (
    <Accordion
      className="p-0"
      triggerClassName="p-4"
      bodyClassName="p-4 pt-0"
      defaultOpen
      head={(
        <div className="flex items-center gap-3">
          <div onClick={(event) => {
            event.stopPropagation();
          }}>
            <BankAccountUpdateModal
              establishmentCompanyId={establishmentCompanyId}
              establishmentCompanyBranchId={establishmentCompanyBranchId}
              bankAccountInformation={bankAccountInformation}
              establishmentCompanyIsLoading={establishmentCompanyIsLoading}
            />
          </div>

          <p className="text-lg font-bold">
            Detalhes bancários
          </p>
        </div>
      )}
      body={(
        <div className='flex flex-col gap-4'>
          <TextField
            label="Banco"
            value={
              !!bankAccountInformation?.bank_institution
                ? `${bankAccountInformation?.bank_institution.code} - ${bankAccountInformation?.bank_institution.name}`
                : undefined
            }
            disabled
          />

          <div className="flex gap-2">
            <TextField
              label="Agência (com dígito)"
              className="grow"
              value={bankAccountInformation?.agency}
              disabled
            />

            <TextField
              label="Conta (com dígito)"
              className="grow"
              value={bankAccountInformation?.account}
              disabled
            />
          </div>

          <div className="flex gap-2">
            <TextField
              label="Nome do favorecido"
              className='grow'
              value={bankAccountInformation?.payee_name}
              disabled
            />

            <TextField
              label="CNPJ/CPF do favorecido"
              className='grow'
              value={bankAccountInformation?.payee_cnpj ? formatCnpjCpf(bankAccountInformation?.payee_cnpj) : ''}
              disabled
            />
          </div>
        </div>
      )}
    />
  );
}
